import http, { API_PREFIX } from '@/services/http'

export const imagesApi = {
  status() {
    return http.get(`${API_PREFIX}/images/status`)
  },
  list(params?: { offset?: number; limit?: number; linked_type?: string; linked_id?: string }) {
    return http.get(`${API_PREFIX}/images/`, { params })
  },
  generate(prompt: string, size: string = '1024x1024') {
    return http.post(`${API_PREFIX}/images/generate`, { prompt, size })
  },
  getMeta(id: string) {
    return http.get(`${API_PREFIX}/images/${id}`)
  },
  link(id: string, linked_type: string | null, linked_id?: string | null, linked_is_primary?: boolean) {
    const body: any = { linked_type, linked_id }
    if (typeof linked_is_primary !== 'undefined') body.linked_is_primary = linked_is_primary
    return http.put(`${API_PREFIX}/images/${id}/link`, body)
  },
  fileUrl(id: string) {
    const base = (typeof window !== 'undefined') ? ( (typeof (http as any).defaults?.baseURL === 'string') ? (http as any).defaults.baseURL : '' ) : ''
    if (base) {
      const trimmedBase = base.endsWith('/') ? base.slice(0, -1) : base
      return `${trimmedBase}${API_PREFIX}/images/${id}/file`
    }
    return `${API_PREFIX}/images/${id}/file`
  },
  getModels(params?: { q?: string; provider_id?: string }) {
    return http.get(`${API_PREFIX}/images/models`, { params })
  },
  createModel(data: { model_id: string; name: string; description?: string; price?: number }) {
    return http.post(`${API_PREFIX}/images/models`, data)
  },
  updateModel(modelId: string, data: { name?: string; description?: string; price?: number }) {
    return http.put(`${API_PREFIX}/images/models/${modelId}`, data)
  },
  deleteModel(modelId: string) {
    return http.delete(`${API_PREFIX}/images/models/${modelId}`)
  },
  getUsageStatistics(days?: number) {
    return http.get(`${API_PREFIX}/images/usage/statistics`, { params: { days } })
  },
  getRecentRequests(limit = 25) {
    return http.get(`${API_PREFIX}/images/usage/recent`, { params: { limit } })
  }
}
